<section class="privacy-notice" aria-labelledby="privacy-heading">
  <div class="container privacy-notice__inner">
    <h1 id="privacy-heading" class="privacy-notice__title">Adatkezelési tájékoztató</h1>
    <p class="privacy-notice__lead">Feltöltés alatt....</p>
  </div>
</section>
